import React from 'react';
import Slider from '../../Home/Slider/Slider';
import './Course.css';

const Course = () => {
  return (
    <div className='main-container-course'>
      {/* <Slider></Slider> */}
      <div className='container-course'>
              {/* 1ST Table for Other Course */}
              <div className="course-other">
        <div data-aos="fade-up"
     data-aos-duration="2000">

          <div className='course-table3'>
            <h1 className='thead3'>COURSE SCHOOL OF PHARMACY</h1>  
            </div>
            <div data-aos="flip-down">
            <table className='table-style3'>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Discipline</th>
                  <th>Intake Seats</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>D.Pharmacy</td>
                  <td>60</td>
                  <td>2 years</td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>
        </div><hr />

      </div>
    </div>
  );
};

export default Course;
